import styled from 'styled-components';

const ItemsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export default ItemsContainer;
